import React from 'react';
import styled from 'styled-components';
import { FiGrid, FiList } from 'react-icons/fi';
import { assetTheme as t } from './assetTheme';

const Wrapper = styled.div`
  display: flex;
  border: 1px solid ${t.borderStrong};
  border-radius: 8px;
  overflow: hidden;
`

const ToggleButton = styled.button`
  border: none;
  background: ${({ $active }) => $active ? t.teal100 : t.surface};
  color: ${({ $active }) => $active ? t.tealDark : t.faint};
  padding: 7px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
`

export default ({ viewMode, onChange }) => {
  return (
    <Wrapper>
      <ToggleButton title='Grid view' $active={viewMode === 'grid'} onClick={() => onChange('grid')}>
        <FiGrid />
      </ToggleButton>
      <ToggleButton title='List view' $active={viewMode === 'list'} onClick={() => onChange('list')}>
        <FiList />
      </ToggleButton>
    </Wrapper>
  )
}
